import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const IdCard = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M4 10a4 4 0 0 1 4-4h32a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V10Zm36 0H8v28h32V10Zm-22.03 9h-4.94c-1.105 0-2.03-.91-2.03-2.015C11 15.91 11.925 15 13.03 15h4.94c1.105 0 2.03.91 2.03 2.015C20 18.09 19.075 19 17.97 19m0 7h-4.94c-1.105 0-2.03-.91-2.03-2.015C11 22.91 11.925 22 13.03 22h4.94c1.105 0 2.03.91 2.03 2.015C20 25.09 19.075 26 17.97 26m-3.985 7h-.97A2.026 2.026 0 0 1 11 30.985C11 29.91 11.91 29 13.015 29h.97c1.104 0 2.015.91 2.015 2.015C16 32.09 15.09 33 13.985 33M29 28a5 5 0 0 0-5 5h-4a9.002 9.002 0 0 1 5.357-8.232 6 6 0 1 1 7.286 0A9.002 9.002 0 0 1 38 33h-4a5 5 0 0 0-5-5Zm-2-8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
